if (process.browser) {
document.addEventListener("DOMContentLoaded", function(){
    document.querySelector(".nav-toggle").addEventListener("click", function(){
        document.querySelector(".site-menu").classList.add("opened");
        document.body.classList.add("no-scroll");
    });
    document.querySelector(".close-menu").addEventListener("click", function(){
        document.querySelector(".site-menu").classList.remove("opened");
        document.body.classList.remove("no-scroll");
    });
})
}